import type { AxiosResponse } from "axios"

import { ApiResponseError, asRecord, requireSuccessfulResponse } from "./api-response"
export interface InboxNotification {
  id: string
  eventKey: string
  title: string
  body: string
  createdAt: string
  readAt: string | null
  deepLink: { type: string; params: Record<string, string> } | null
}
const date = (value: unknown): value is string => typeof value === "string" && Number.isFinite(Date.parse(value))
function validItem(value: unknown): value is InboxNotification {
  const row = asRecord(value),
    link = asRecord(row?.deepLink),
    params = asRecord(link?.params)
  return (
    !!row &&
    typeof row.id === "string" &&
    !!row.id &&
    typeof row.eventKey === "string" &&
    typeof row.title === "string" &&
    typeof row.body === "string" &&
    date(row.createdAt) &&
    (row.readAt === null || date(row.readAt)) &&
    (row.deepLink === null ||
      (!!link &&
        typeof link.type === "string" &&
        !!params &&
        Object.values(params).every((v) => typeof v === "string")))
  )
}
export function inboxPage(response: AxiosResponse, cursor?: string, limit = 20) {
  requireSuccessfulResponse(response)
  const body = asRecord(response.data),
    items = body?.items,
    next = body?.nextCursor,
    count = body?.unreadCount
  if (
    body?.success !== true ||
    !Array.isArray(items) ||
    !items.every(validItem) ||
    items.length > Math.min(limit, 50) ||
    new Set(items.map((r) => r.id)).size !== items.length ||
    !Number.isSafeInteger(count) ||
    (count as number) < 0 ||
    (next !== null && (typeof next !== "string" || !next || next === cursor || items.length === 0))
  )
    throw new ApiResponseError("Invalid notification page. Please retry.", response)
  return { items: items as InboxNotification[], nextCursor: next as string | null, unreadCount: count as number }
}
export function inboxCount(response: AxiosResponse) {
  requireSuccessfulResponse(response)
  const body = asRecord(response.data)
  if (body?.success !== true || !Number.isSafeInteger(body.count) || (body.count as number) < 0)
    throw new ApiResponseError("Invalid notification count. Please retry.", response)
  return body.count as number
}
